import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo2_Bernardo } from '../../../../../utils/EN/Modals/directors';

const ModalVideoBernardo2 = () => {
  return (
    <>
      <ModalVideo
        id="bernardo-video-2"
        dataText={TextVideo2_Bernardo}
        videoSrc="https://player.vimeo.com/video/698689586?h=f11a6ade35&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_BERNARDO_2"
      />
    </>
  );
};

export default ModalVideoBernardo2;
